<template>
  <div class="bg-dark h-100 py-5 mt-5">
    <div class="container bg-dark">
      <div class="card card-login mx-auto mt-5 p-0">
        <div class="card-header">ავტორიზება</div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <div class="form-label-group">
                <input
                  type="text"
                  id="inputUserName"
                  class="form-control"
                  placeholder="User Name"
                  autofocus="autofocus"
                  v-model="login.userName"
                  v-on:input="$v.login.$touch"
                  v-bind:class="{
                    'error-border': $v.login.userName.$error,
                    valid:
                      $v.login.userName.$dirty && !$v.login.userName.$invalid,
                  }"
                />
                <label for="inputUserName">მომხმარებელი</label>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label-group">
                <input
                  type="password"
                  id="inputPassword"
                  class="form-control"
                  placeholder="Password"
                  v-model="login.password"
                  v-on:keyup.enter="$v.login.$touch(), loginClick()"
                  v-on:input="$v.login.$touch"
                  v-bind:class="{
                    'error-border': $v.login.password.$error,
                    valid:
                      $v.login.password.$dirty && !$v.login.password.$invalid,
                  }"
                />
                <label for="inputPassword">პაროლი</label>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label-group">
                <a href="#" @click="resetPassword()">პაროლის აღდგენა</a>
              </div>
            </div>
            <a
              class="btn btn-primary btn-block mt-5"
              @click="$v.login.$touch(), loginClick()"
              :disabled="loading"
            >
              <span v-show="!loading"> შესვლა </span>
              <span v-show="loading"> იტვირთება... </span>
            </a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/scss/_login.scss";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";

export default {
  name: "login",
  data() {
    return {
      login: {
        userName: null,
        password: null,
      },
      loading: false,
    };
  },
  validations: {
    login: {
      userName: {
        required,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    async loginClick() {
      if (this.loading) return;
      this.loading = true;
      var loginResult = "";
      try {
        loginResult = await this.$http.login({
          userName: this.login.userName,
          password: this.login.password,
        });
        console.log(loginResult.data);

        if (loginResult.status == "200") {
          //bus.$emit("success", "1");
          localStorage.setItem("token", loginResult.data.res.token);
          localStorage.setItem("userName", loginResult.data.res.userName);
          this.$router.push("/profile");
        } else {
          bus.$emit("warning", "2");
        }
      } catch (error) {
        bus.$emit("error", error);
      } finally {
        this.loading = false;
      }
    },

    resetPassword() {
      this.$router.push("/resetPassword");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/Login.vue